module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "never",
      "header": "管理员信息"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "账户"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.id) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "大头照"
    }
  }, [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.form.head_portrait,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), (_vm.change_pwd) ? [_c('el-form-item', {
    attrs: {
      "label": "修改密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": _vm.new_input_type,
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.pwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "pwd", $$v)
      },
      expression: "form.pwd"
    }
  }, [_c('i', {
    staticClass: "el-icon-view",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "suffix",
      "title": "隐藏密码"
    },
    on: {
      "click": _vm.changeNewPass
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认修改密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": _vm.input_type,
      "placeholder": "请输入确认密码"
    },
    model: {
      value: (_vm.form.repwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "repwd", $$v)
      },
      expression: "form.repwd"
    }
  }, [_c('i', {
    staticClass: "el-icon-view",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "suffix",
      "title": "隐藏密码"
    },
    on: {
      "click": _vm.changePass
    },
    slot: "suffix"
  })])], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f631f3f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f631f3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shop/admininfo.vue
// module id = 2524
// module chunks = 0